import { render, staticRenderFns } from "./dynamicControls.vue?vue&type=template&id=0a8649e9&"
import script from "./dynamicControls.vue?vue&type=script&lang=js&"
export * from "./dynamicControls.vue?vue&type=script&lang=js&"
import style0 from "./dynamicControls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dynamicControls.vue"
export default component.exports